import {useContext} from "react";
import {NotificationContext} from "../providers/notification.provider";

export function useCopyToClipboard() {
    const {dispatch} = useContext(NotificationContext)!;

    async function copyToClipboard(text: string) {
        try {
            await navigator.clipboard.writeText(text);
            dispatch({
                type: "ADD_NOTIFICATION",
                payload: {title: "Copied!", message: "Text copied to clipboard.", status: "success"}
            });
        } catch (e) {
            console.error(e);
            dispatch({
                type: "ADD_NOTIFICATION",
                payload: {title: "Copied!", message: "Failed to copy to clipboard.", status: "error"}
            });
        }
    }

    return copyToClipboard;
}
